import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { WebviewCartaoGestanteComponent } from './subpages/webview-cartao-gestante/webview-cartao-gestante.component';
import { WebviewGuard } from 'app/core/guards/webview.guard';

const routes: Routes = [
  {
    path: 'webview', 
    component: WebviewCartaoGestanteComponent,
    canActivate: [WebviewGuard]
  },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class WebviewRoutingModule { }
